import React, { useState, Fragment } from 'react';
import classNames from 'classnames';
import mainStyles from '../../../styles.module.scss';
import _ from 'lodash';
import { YamlSettingsViewModal } from '../yaml-settings-view-modal/YamlSettingsViewModal';
import ReactTooltip from 'react-tooltip';
import { CCMClientSettingsConfig } from '../../../config/CCMClientSettingsConfig';

export const YamlSettingsViewComponent = ({ yamlDetails, disableViewYamlSettings, submitStatus = '' }) => {
  const {
    SYNC_STATUS_MESSAGE_VALIDATION_RESPONSE: { SUCCESSFUL }
  } = CCMClientSettingsConfig;
  const [isViewYamlModalOpen, setIsViewYamlModalOpen] = useState(false);
  const [jsonDetails, setJsonDetails] = useState(null);
  const [hover, setHover] = useState(false);

  const handleViewYaml = () => {
    setIsViewYamlModalOpen(true);
    setJsonDetails(yamlDetails);
  };

  return (
    <Fragment>
      {!_.isNil(jsonDetails) && (
        <YamlSettingsViewModal
          title="View Yaml Settings"
          isOpen={isViewYamlModalOpen}
          data={jsonDetails}
          modalActions={{ closeModal: () => setIsViewYamlModalOpen(false) }}
        />
      )}
      <span data-tip="React-tooltip" data-for="yamlTooltip">
        <button
          id="viewYamlButton"
          className={classNames(mainStyles.secondaryBtn, {
            [mainStyles.actionButton]: true,
            [mainStyles.regularBtn]: true
          })}
          onClick={handleViewYaml}
          disabled={disableViewYamlSettings}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {submitStatus === SUCCESSFUL ? 'VIEW ACTIVE YAML SETTINGS' : 'LAST SUBMITTED YAML SETTINGS'}
        </button>
        {hover && disableViewYamlSettings && (
          <ReactTooltip id="yamlTooltip" multiline border type="light" effect="solid" place="top" className="text-left">
            <div className="whitespace-pre">{`Client has not been submitted yet`}</div>
          </ReactTooltip>
        )}
      </span>
    </Fragment>
  );
};
